import { FormFieldType } from '../typings';
import type { FormPrimitiveValues, SingleFormField } from '../typings';

/** Empty Formik value for a single field, matching what the server stores once a field is Not Applicable. */
export const getClearedFieldValue = (
  field: SingleFormField,
): FormPrimitiveValues => (field.type === FormFieldType.Checkbox ? false : '');

/** True when the field still holds a value that Not Applicable has to wipe from the UI. */
export const shouldClearFieldValue = (
  clearedValue: FormPrimitiveValues,
  currentValue: unknown,
): boolean => {
  // undefined means Formik holds no such key — writing one would register a bogus change.
  if (currentValue === undefined || currentValue === null) return false;

  return currentValue !== clearedValue;
};
